"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var permissions_1 = require("./permissions");
exports.Permissions = permissions_1.Permissions;
exports.PERMISSION_LIST = permissions_1.PERMISSION_LIST;
//# sourceMappingURL=index.js.map